// @flow weak

import React, { Component } from 'react';
import PropTypes    from 'prop-types';
import UserMenu     from './userMenu/UserMenu';
import TaskMenu     from './taskMenu/TaskMenu';
import MessageMenu  from './messageMenu/MessageMenu';
import Button       from './button/Button';
import { createHashHistory } from "history";
import isEmpty        from "lodash.isempty";
import { withRouter } from "react-router-dom";
import { compose }    from "redux";
import headerLogo from '../../img/ddb.png'
const history = createHashHistory();

class Header extends Component{
  constructor(props) {
    super(props);
    this.state = {
      filterType: "customerEmail",
      filterText: "",
      defaultSite: "",
    };

    this.handleCustomerSearch = this.handleCustomerSearch.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentWillMount(){
    let siteID = (localStorage.getItem("siteID")) ? localStorage.getItem("siteID") : '';
    this.setState({defaultSite: siteID})
  }
  
  handleSite = (e) => {
    localStorage.setItem("siteID", e.target.value);
    this.setState({defaultSite: e.target.value});
    window.location.reload();
  }
  componentWillReceiveProps(nextProps) {
    if(nextProps.location && nextProps.location.pathname.indexOf('/search/') ==0){
      let filterArray = nextProps.location.pathname.split("/");
      if(!isEmpty(filterArray)){
        this.setState({
          filterType:filterArray[2],
          filterText:filterArray[3]
        });
      }
    }
    else
    {
      this.setState({
        filterType: "customerEmail",
        filterText: ""
      });
    }
  }

  handleInputChange = event => {
    this.setState({
      [event.target.name]: event.target.value
    });
  };

  handleCustomerSearch() {
    if(!isEmpty(this.state.filterText)){
      history.push(`/search/`+this.state.filterType+'/'+this.state.filterText);
    }
  }

  render(){
    let siteName = (localStorage.getItem("subadmin_sites_detail")) ? JSON.parse(localStorage.getItem("subadmin_sites_detail")) : [];

    const {
      appName,
      currentView,
      userLogin,
      userFirstname,
      userLastname,
      userPicture,
      showPicture,
      toggleSideMenu,
      onLogout
    } = this.props;

    var TextStyle = {
      // width: '40%',
      // marginRight: '50px'
    }

    return(
        <header
          className="header fixed--header">
          <a href="#" className="logo">{/* { appName } */}<img src={headerLogo} className="pull-left" width="170px" /></a>
          <nav className="navbar navbar-static-top" role="navigation">
                <Button toggleSideMenu={toggleSideMenu} />
                <img src={headerLogo} className="mobile-logo" />
                <div className="col-xs-3">
                  <select
                    name="defaultSite"
                    className="form-control"
                    value={this.state.defaultSite}
                    onChange={this.handleSite} >
                    {(!isEmpty(siteName)) &&
                      siteName.map((site, index) =>
                        Object.keys(site).map((key, indexkey) =>
                          <option value={key}>{site[key]}</option>
                        )
                      )
                    }
                  </select>
                </div>
                <div className="navbar-right" style={TextStyle}>
                  <div className="customerSearch">
                    <div className="row ">
                      <div className="col-xs-5">
                        <select
                          name="filterType"
                          className="form-control"
                          value={this.state.filterType}
                          onChange={this.handleInputChange} >
                          <option value="customerEmail">Customer Email</option>
                          <option value="customerName">Customer Name</option>
                          <option value="orderID">Order ID</option>
                          <option value="offers">Offers</option>
                          <option value="vouchers">Voucher Code</option>
                        </select>
                      </div>
                      <div className="col-xs-5">
                        <input
                          type="text"
                          className="form-control"
                          name="filterText"
                          autoComplete="off"
                          id="filterText"
                          placeholder="Enter Text"
                          value={this.state.filterText}
                          onChange={this.handleInputChange}
                        />
                      </div>
                      <div className="col-xs-2">
                        <button
                          id="send"
                          onClick={this.handleCustomerSearch}
                          type="submit"
                          className="btn btn-success"
                        >
                          <i className="fa fa-search" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </nav>
        </header>
      )
  }
}

// const Header = ({
//   userLogin,
//   userFirstname,
//   userLastname,
//   userPicture,
//   showPicture,
//   appName,
//   toggleSideMenu,
//   onLogout
// }) => ();

Header.propTypes = {
  appName:        PropTypes.string,
  userLogin:      PropTypes.string,
  userFirstname:  PropTypes.string,
  userLastname:   PropTypes.string,
  userPicture:    PropTypes.string,
  showPicture:    PropTypes.bool,
  onLogout:       PropTypes.func,
  currentView:    PropTypes.string,
  toggleSideMenu: PropTypes.func
};

Header.defaultProps = {
  appName: 'applicationName'
};

Header.displayName = 'Header';

export default  compose(withRouter)(Header);



// WEBPACK FOOTER //
// ./src/app/components/header/Header.js